import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../utils/axios'


const initialState = {
    data: [],
    status: 'idle',
};

export const getCategories = createAsyncThunk('/categories/get', async () => {

    let res = axios.get('categories',{
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      }).catch((err)=>{
        console.log(err)
        // setError(err.response.data.message)
      })
      
      
      const data = await res
      console.log(data);
      return data.data.data.categories


    
})

export const createCategory = createAsyncThunk('/categories/create', async (item) => {

    let res = axios.post('categories', item,{
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      }).catch((err)=>{
        console.log(err)
        // setError(err.response.data.message)
      })
      
      
      const data = await res
      console.log(data);
      if(data.data.success){
        alert("Kategoriya yaratildi")
      }


    
})
export const deleteCategory = createAsyncThunk('/categories/delete', async (item) => {

    let res = axios.delete(`categories/${item.parent._id}`,{
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      }).catch((err)=>{
        console.log(err)
        // setError(err.response.data.message)
      })
      
      
      const data = await res
      console.log(data);
      if(data.data.success){
        alert("Kategoriya o'chirildi")
      }


    
})
const categories = createSlice({
    name: 'projects',
    initialState,
    reducers: {},
    extraReducers(builder) {
      builder
      .addCase(getCategories.pending, (state, action) => {
        state.status = 'loading'
      })
      .addCase(getCategories.rejected, (state, action) => {
        state.status = 'failed'
      })
      .addCase(getCategories.fulfilled,(state, action) => {
        // state.status = "idle";
        console.log(action.payload, 'payload');
        state.data = action.payload;
        state.status = 'succeeded'
      })
      .addCase(createCategory.fulfilled, (state, action) => {
        state.status = 'idle'
      })
      .addCase(deleteCategory.fulfilled, (state, action) => {
        state.status = 'idle'
      })
      }
  });
export const reducer = categories.reducer;